export interface Brand {
  storeId: string;
  id: string; // UUID
  name: string;
  keywords: string;
  metaDescription: string;
  metaTitle: string;
  permalink: string;
  score: number;
  status: string;
  externalId?: string;
}
export interface BrandDetailResponse {
  id: string; // UUID
  name: string;
  keywords: string;
  metaDescription: string;
  metaTitle: string;
  permalink: string;
  score: number;


}
export enum BrandDtoStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export interface BrandListFilter {
  storeId: string;
  page?: number;
  size?: number;
  name?: string;
  status?: string;
  keywords?: string;
  actualSearch?: string,
  sort?: string[];

}

export interface PageDto {
  number: number;
  size: number;
  totalElements: number;
  totalPages: number;
  empty: boolean;
}

export interface BrandDtoResponse {
  page: PageDto;
  items: Brand[];
}
export interface CreateBrandResponse {
  id: string;
}

export interface BatchBrandDetails {
  code: string;
  message: string;
}

export interface BatchBrandResponse {
  operation: string;
  totalProcessed: number;
  successful: number;
  failed: number;
  details: BatchBrandDetails;
}

export enum BrandErrorResponseEnum {
  BRAND_NOT_FOUND = 'Marca no encontrada',
  BRAND_PERMALINK_ALREADY_TAKEN = 'El permalink ya está en uso',
  BRAND_PATCH_ACTION = 'La acción para actualizar no es reconocida',
  BRAND_DISABLE_ERROR = 'Error al deshabilitar una marca',
  BRAND_ENABLE_ERROR = 'Error al habilitar una marca',
  BRAND_UPDATE_ERROR = 'Ocurrió un error al actualizar la marca',
  BRAND_NAME_ALREADY_EXISTS = 'Ya existe una marca con ese nombre',
  DEFAULT = 'Ha ocurrido un error inesperado',
  BRAND_HAS_ASSOCIATED_PRODUCTS = 'No se puede eliminar la marca porque tiene productos asociados.',
}

